module.exports = __webpack_public_path__ + "img/286.81d2df06.png";